import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { RubricAction, RubricActionType } from '../actionTypes/rubric';
import { PostDispatch, EvaluationRubricBase } from '../types';

export const getRubrics = () => async (dispatch: Dispatch<PostDispatch>) => {
    const response = await SuSyApi.get(`/rubric`);
    dispatch({ type: RubricActionType.GET_RUBRICS, payload: response.data });
};

export const getProjectRubrics =
    (projectId: string) => async (dispatch: Dispatch<RubricAction>) => {
        const response = await SuSyApi.get(`/rubric/${projectId}`);
        dispatch({
            type: RubricActionType.GET_PROJECT_RUBRICS,
            payload: response.data,
        });
    };

export const createRubric =
    (
        rubric: EvaluationRubricBase,
        shouldPublish: boolean,
        callback?: () => void
    ) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(`/rubric`, {
            rubric,
            shouldPublish,
        });
        dispatch({
            type: RubricActionType.CREATE_RUBRIC,
            payload: response.data,
        });
        callback && callback();
    };

export const updateRubric =
    (
        rubric: EvaluationRubricBase,
        shouldPublish: boolean,
        callback?: () => void
    ) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(`/rubric/${rubric._id}`, {
            rubric,
            shouldPublish,
        });
        dispatch({
            type: RubricActionType.UPDATE_RUBRIC,
            payload: response.data,
        });
        callback && callback();
    };

export const deleteRubric =
    (rubricId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.delete(`/rubric/${rubricId}`);
        dispatch({
            type: RubricActionType.DELETE_RUBRIC,
            payload: response.data,
        });
    };
